import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../OPL/Box/Box';
import { Text } from '../OPL/Text/Text';
import { selectFooterDisclosures } from '../../CommonSelectors/CommonAreaSelector';

export const FooterDisclosures = () => {
  const footerDisclosures = useSelector(selectFooterDisclosures);

  if (footerDisclosures.length === 0) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={8}
      maxWidth={1200}
      mx="auto"
      my="24"
      px="32"
    >
      {footerDisclosures.map((disclosure, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          {disclosure.Header && (
            <Text fontSize="small" color="neutral.500">
              <strong>{disclosure.Header}</strong>
            </Text>
          )}

          {disclosure.Body && (
            <Text fontSize="small" color="neutral.500">
              {disclosure.Body}
            </Text>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};
